var _circle, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntercom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#25AB75"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_8074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.125 20C68.6831 20 70.1775 20.7902 71.2793 22.1967C72.381 23.6032 73 25.5109 73 27.5V75.4738C72.9999 75.8448 72.9137 76.2074 72.7521 76.5158C72.5905 76.8242 72.3609 77.0644 72.0923 77.2062C71.8237 77.3479 71.5283 77.3847 71.2433 77.312C70.9583 77.2392 70.6966 77.0602 70.4914 76.7975L62.1107 66.0988C61.5599 65.3954 60.8129 65.0002 60.0339 65H31.875C30.3169 65 28.8225 64.2098 27.7207 62.8033C26.619 61.3968 26 59.4891 26 57.5V27.5C26 25.5109 26.619 23.6032 27.7207 22.1967C28.8225 20.7902 30.3169 20 31.875 20H67.125Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 46.478C47.7563 51.9855 53.245 51.8201 63 46.478",
    stroke: "#25AB75",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_8074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 60,
    fill: "white",
    transform: "matrix(-1 0 0 1 73 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntercom);
export default __webpack_public_path__ + "static/media/intercom.c2748b2e8f21565c65ff30a5c882fd3a.svg";
export { ForwardRef as ReactComponent };